/* -------------------------------------------------------------------------- */
/*                                   Datatable                                  */
/* -------------------------------------------------------------------------- */

import { ENUM_UNITS } from '@config/constants/units';
import i18n from '@config/i18n/config';
import { TProductionPopulatedParsed } from '@features/sourcing/productions/types';
import sumBy from 'lodash/sumBy';

export function addFooterColumn(
	productions: TProductionPopulatedParsed[],
	columns: any
) {
	const _newColumns = columns.map((item: any) => {
		const footerType = item?.footerType;
		switch (footerType) {
			case 'sumProductions':
				const sumProductions = sumBy(
					productions,
					function (o) {
						return o.productionNumeric;
					}
				);
				item.footer = `${sumProductions.toFixed(3)} ${ENUM_UNITS.MWH}`;
				return item;

			case 'sumTokenEquivalents':
				item.footer = 'sumTokenEquivalents';
				const sumTokenEquivalents = sumBy(
					productions,
					function (o) {
						return o.tokenEquivalentNumeric;
					}
				);
				item.footer = `${sumTokenEquivalents.toFixed(3)} ${ENUM_UNITS.tco2e}`;
				return item;

			case 'sumProjectsProductions':
				const uniqueProductionsByProject = [
					...new Set(
						productions.map((item) => item.projectId)
					),
				];

				item.footer = 'sumProjectsProductions';

				item.footer = `∑ ${uniqueProductionsByProject.length} ${i18n.t('global.projects')}`;
				return item;

			case 'sumSitesProductions':
				const uniqueProductionsBySite = [
					...new Set(
						productions.map((item) => item.siteId)
					),
				];

				item.footer = 'sumProjectsProductions';

				item.footer = `∑ ${uniqueProductionsBySite.length} ${i18n.t('global.sites')}`;
				return item;

			case 'sumOrganizationsProductions':
				const uniqueProductionsByOrganization = [
					...new Set(
						productions.map((item) => item.siteId)
					),
				];

				item.footer = 'sumOrganizationsProductions';

				item.footer = `∑ ${uniqueProductionsByOrganization.length} ${i18n.t('global.organizations')}`;
				return item;

			case 'sumVerifiedProductions':
				const uniqueProductionsByVerified =
					productions.filter((item) => item.verified);

				item.footer = 'sumVerifiedProductions';

				item.footer = `∑ ${uniqueProductionsByVerified.length} ${i18n.t('global.verified')}`;
				return item;

			case 'sumMintStatusProductions':
				const uniqueProductionsByMintStatus =
					productions.filter(
						(item) => item.status === 'MINTED'
					);

				item.footer = 'sumMintStatusProductions';

				item.footer = `∑ ${uniqueProductionsByMintStatus.length} ${i18n.t('global.Minted')}`;
				return item;

			default:
				return item;
		}
	});

	return _newColumns;
}
